export const focusAreas = {
  localSEO: {
    title: "Local SEO Mastery",
    icon: "LocationOn",
    symptoms: [
      "Not appearing in 'near me' or local Google searches",
      "Competitors outranking you for Saskatchewan searches",
      "Google Business Profile incomplete or unoptimized",
      "Missing from local directories and citations"
    ],
    impacts: [
      "Missing out on high-intent local customers actively searching",
      "Losing business to competitors who appear first",
      "Lower foot traffic and phone inquiries",
      "Reduced visibility in your target Saskatchewan markets"
    ],
    solutions: [
      "Optimize Google Business Profile with Saskatchewan-specific keywords",
      "Build local citations across Saskatchewan directories",
      "Implement location-based schema markup",
      "Generate and manage authentic local customer reviews",
      "Create location-specific landing pages for key Saskatchewan cities"
    ],
    nextSteps: [
      "Claim and fully optimize your Google Business Profile",
      "Audit current local search rankings for key terms",
      "Build citations in Saskatchewan business directories",
      "Implement a local review generation strategy"
    ],
    insight: "Local SEO is crucial for Saskatchewan businesses. 46% of all Google searches have local intent, and 76% of people who search for something nearby visit a business within 24 hours. Optimizing for local search ensures you're visible when customers in your area are ready to buy."
  },
  technicalSEO: {
    title: "Technical SEO Foundation",
    icon: "Settings",
    symptoms: [
      "Website loads slowly on mobile or desktop",
      "Pages not indexed properly by Google",
      "Broken links or technical errors on site",
      "Poor mobile responsiveness affecting rankings"
    ],
    impacts: [
      "Google penalizes slow, poorly structured sites in rankings",
      "High bounce rates from frustrated visitors",
      "Lost opportunities as search engines can't crawl your content",
      "Decreased mobile traffic as users abandon slow pages"
    ],
    solutions: [
      "Implement technical SEO audit and fix critical issues",
      "Optimize site speed and Core Web Vitals",
      "Ensure mobile-first responsive design",
      "Create proper XML sitemap and robots.txt",
      "Fix crawl errors, broken links, and duplicate content",
      "Implement SSL certificate and secure HTTPS"
    ],
    nextSteps: [
      "Run comprehensive technical SEO audit",
      "Test and optimize mobile page speed",
      "Submit sitemap to Google Search Console",
      "Fix any crawl errors or indexing issues"
    ],
    insight: "Technical SEO forms the foundation of all search visibility. Even the best content won't rank if Google can't properly crawl and index your site. Page speed alone affects rankings - sites loading in 2 seconds have a 9% bounce rate, while 5-second loads see 38% bounce rates."
  },
  contentOptimization: {
    title: "Strategic Content Optimization",
    icon: "Article",
    symptoms: [
      "Website content lacks relevant local keywords",
      "No fresh content published regularly",
      "Pages don't target specific search queries",
      "Low engagement and time-on-site metrics"
    ],
    impacts: [
      "Missing opportunities to rank for valuable search terms",
      "Competitors capturing traffic with better optimized content",
      "Lower authority and trust from search engines",
      "Reduced organic traffic and lead generation"
    ],
    solutions: [
      "Conduct keyword research focused on Saskatchewan market",
      "Create high-quality, locally-relevant content regularly",
      "Optimize existing pages with strategic keywords",
      "Develop content targeting different buyer journey stages",
      "Build topical authority with comprehensive coverage",
      "Optimize meta titles, descriptions, and headers"
    ],
    nextSteps: [
      "Perform keyword research for your Saskatchewan niche",
      "Audit existing content for optimization opportunities",
      "Create content calendar targeting key search terms",
      "Optimize top-performing pages for better rankings"
    ],
    insight: "Content is the vehicle that drives SEO success. Websites that blog regularly get 55% more traffic than those that don't. Strategic content optimization helps you capture qualified traffic at every stage of the buyer journey, from awareness to decision, while establishing your authority in the Saskatchewan market."
  }
};
